module.exports = __webpack_public_path__ + "static/zdjęcia13-3dd6ad09e5248fd2972527de0957de99.svg";